<template>
  <div class="td">
    <div class="sub-header">
      {{ data.caption }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
.td {
  flex: none;
  .sub-header {
    font-size: 2em;
    opacity: 0;

    .table-row:first-child & {
      opacity: 1;
    }
    .table-header & {
      opacity: 1;
      font-size: 1.875em;
    }

    .table-header.bordered ~ .table-body & {
      opacity: 0;
      font-size: 1.875em;
    }
    .table-super-header & {
      opacity: 0;
      font-size: 1.875em;
    }
  }
  &:nth-child(n + 2) {
    .sub-header {
      padding-left: 5em;
    }
  }
}
</style>
